import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuth } from "../interfaces/IAuth";
import { IUser } from "../interfaces/IUser";

const initialState: IAuth = {
  user: null,
  userId: null,
  accessToken: null,
  sessionScope: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authChange: (state, action: PayloadAction<IAuth | undefined>) => {
      const payload = action.payload;

      if (payload) {
        state.accessToken = payload.accessToken;
        state.sessionScope = payload.sessionScope;
        state.user = payload.user;
        state.userId = payload.userId;
      } else {
        state.user = null;
        state.userId = null;
        state.accessToken = null;
        state.sessionScope = null;
      }
    },

    authMe: (state, action: PayloadAction<IUser>) => {
      const payload = action.payload;

      const uniqueModules = payload?.permissions?.map((item: any) => item.module)?.filter((item, pos, self) => self.indexOf(item) === pos);

      state.user = {
        ...payload,
        myModules: uniqueModules,
      };

      state.userId = payload.id;
    },
  },
});

export const authReducer = authSlice.reducer;

export const { authChange, authMe } = authSlice.actions;
